import { render, staticRenderFns } from "./EligibleProfessionals.vue?vue&type=template&id=29006a9c"
import script from "./EligibleProfessionals.vue?vue&type=script&lang=js"
export * from "./EligibleProfessionals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports